/* eslint-disable no-return-await */
import {Repository} from './Repository'

export default {
  async login (loginData) {
    return await Repository.post(`/auth/login`, loginData)
  },
  async loginWithOtp (loginData) {
    return await Repository.post(`/auth/loginWithOtp`, loginData)
  },
  async sendOtp (loginData) {
    return await Repository.post(`/auth/sendOtp`, loginData)
  },
  async getCodes () {
    return await Repository.get('/api/codes')
  },
  async register (registrationData) {
    let output = await Repository.post('/auth/register', registrationData)
    return output.data
  },
  async postUserProfile (data) {
    let output = await Repository.post('/api/customerProfile', data)
    return output
  },
  async getCustomerProfile () {
    let output = await Repository.get('/api/getCustomerProfile')
    return output
  },
  async changePassword (data) {
    let output = await Repository.post('/api/changePassword', data)
    return output
  },
  async forgotPassword (data) {
    let output = await Repository.post('/password/reset-request', data)
    return output
  },
  async resetPassword (data) {
    let output = await Repository.post('/password/reset', data)
    return output
  }
}



// WEBPACK FOOTER //
// ./src/repositories/userRepository.js